export const tableColumnsWidths = {
  nameWidth: "20%",
  orderCodeWidth: "20%",
  quantityWidth: "7%",
  unitPriceWidth: "13%",
  totalPriceWidth: "13%",
  priceGroupWidth: "27%",
} as const;
